import { Link } from "react-router-dom";
import { hotNews } from "@/mocks/hotNews";
import NewsCard from "@/components/feature/NewsCard";
import { getCategory, formatViews } from "@/utils/content";

export default function HomeFeed() {
  const featured = hotNews.find((n) => n.featured)!;
  const rest = hotNews.filter((n) => n.slug !== featured.slug).slice(0, 4);
  const grid = hotNews.filter((n) => n.slug !== featured.slug).slice(4, 10);
  const fcat = getCategory(featured.categoryId);

  return (
    <section className="container-x py-10 md:py-14">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="chip bg-primary-100 text-primary-800 px-3 py-1 text-xs font-bold">
            <i className="ri-article-line"></i> 最新新鲜事
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl">刚出炉的瓜，趁热看</h2>
        </div>
        <Link to="/news" className="hidden shrink-0 text-sm font-medium text-primary-600 hover:text-primary-700 sm:inline-flex">
          全部新鲜事 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {/* featured big */}
        <article className="group card-surface overflow-hidden lg:col-span-2">
          <Link to={`/news/detail/${featured.slug}`} className="grid sm:grid-cols-2">
            <div className="relative aspect-[4/3] w-full overflow-hidden sm:aspect-auto sm:min-h-[260px]">
              <img src={featured.image} alt={`${featured.title} - 头条热瓜`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <span className="chip absolute left-3 top-3 bg-primary-600 text-background-50 px-2.5 py-1 text-xs font-bold">
                编辑精选
              </span>
            </div>
            <div className="flex flex-col p-5 md:p-6">
              <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                <i className={fcat.icon}></i>{fcat.name}
              </span>
              <h3 className="mt-2 text-xl font-bold leading-snug group-hover:text-primary-700 transition-colors">{featured.title}</h3>
              <p className="mt-2 text-sm text-foreground-600">{featured.summary}</p>
              <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-user-3-line"></i>{featured.author}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{formatViews(featured.views)}</span>
              </div>
            </div>
          </Link>
        </article>

        {/* compact list */}
        <div className="flex flex-col gap-3">
          {rest.map((item) => {
            const cat = getCategory(item.categoryId);
            return (
              <Link key={item.slug} to={`/news/detail/${item.slug}`} className="group flex gap-3 rounded-2xl bg-background-100 border border-background-200/80 p-3 transition-colors hover:bg-background-200/60">
                <div className="h-16 w-24 shrink-0 overflow-hidden rounded-lg">
                  <img src={item.image} alt={item.title} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0">
                  <h3 className="line-clamp-2 text-sm font-semibold leading-snug group-hover:text-primary-700 transition-colors">{item.title}</h3>
                  <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className={cat.icon}></i>{item.date} · 热度 {item.heat}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {grid.map((item) => (
          <NewsCard key={item.slug} item={item} />
        ))}
      </div>
    </section>
  );
}